import React, { ChangeEventHandler, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, FormControl, FormLabel, Input } from '@chakra-ui/react';
import InputMask from 'react-input-mask';

interface Props {
  values: ModalFormPaymentMethod;
  handleChange: ChangeEventHandler<HTMLInputElement | HTMLSelectElement>;
}

export default ({ values, handleChange }: Props): ReactElement => {
  const { t } = useTranslation();
  const expirationDatePattern = '(?:0[1-9]|1[0-2])/[0-9]{2}';

  return (
    <>
      <Flex mb="6">
        <FormControl id="cardNumber">
          <Input
            name="cardNumber"
            onChange={handleChange}
            placeholder={t('new_payment_method.card_number')}
            required
            type="number"
            value={values.cardNumber}
          />
          <FormLabel>{t('new_payment_method.card_number')}</FormLabel>
        </FormControl>
      </Flex>

      <Flex mb="6">
        <FormControl id="expDate" mr="4">
          <Input
            as={InputMask}
            mask="99/99"
            maskChar="_"
            name="expDate"
            onChange={handleChange}
            pattern={expirationDatePattern}
            placeholder={t('new_payment_method.exp_date')}
            required
            value={values.expDate}
          />
          <FormLabel>{t('new_payment_method.exp_date')}</FormLabel>
        </FormControl>
        <FormControl id="securityCode" width="120px">
          <Input
            name="securityCode"
            onChange={handleChange}
            placeholder={t('new_payment_method.security_code')}
            required
            type="number"
            value={values.securityCode}
          />
          <FormLabel>{t('new_payment_method.security_code')}</FormLabel>
        </FormControl>
      </Flex>

      <Flex mb="6">
        <FormControl id="cardFirstName">
          <Input
            name="cardFirstName"
            onChange={handleChange}
            placeholder={t('new_payment_method.first_name')}
            required
            type="text"
            value={values.cardFirstName}
          />
          <FormLabel>{t('new_payment_method.first_name')}</FormLabel>
        </FormControl>
      </Flex>

      <Flex mb="6">
        <FormControl id="cardLastName">
          <Input
            name="cardLastName"
            onChange={handleChange}
            placeholder={t('new_payment_method.last_name')}
            required
            type="text"
            value={values.cardLastName}
          />
          <FormLabel>{t('new_payment_method.last_name')}</FormLabel>
        </FormControl>
      </Flex>
    </>
  );
};
